module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-208.f04cbd72.svg";